export const ENV = {
    apiUrl: process.env.REACT_APP_NEXT_PUBLIC_API_URL,
    staticFileUrl: process.env.REACT_APP_NEXT_PUBLIC_STATIC_FILE_URL + '/api/v1/file/',
};
